var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1320_8691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 2.73914L7.22673 3.43665H7.96009L7.36676 3.86772L7.59341 4.56523L7.00008 4.13413L6.40672 4.56523L6.63337 3.86772L6.04004 3.43665H6.77343L7.00008 2.73914Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98734 3.98711L4.64086 4.32005L5.15943 3.8015L5.04467 4.52583L5.69816 4.8588L4.97379 4.97353L4.85906 5.69792L4.52609 5.04444L3.80176 5.1592L4.32033 4.64062L3.98734 3.98711Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73926 7L3.43677 6.77335V6.03996L3.86782 6.63332L4.56536 6.40667L4.13423 7L4.56536 7.59333L3.86782 7.36671L3.43677 7.96004V7.22665L2.73926 7Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98734 10.0129L4.3203 9.35938L3.80176 8.84081L4.52612 8.9556L4.85903 8.30211L4.97379 9.02647L5.69813 9.14121L5.04472 9.47417L5.15943 10.1985L4.64086 9.67993L3.98734 10.0129Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 11.2609L6.7734 10.5634H6.04004L6.6334 10.1323L6.40672 9.43483L7.00008 9.86588L7.59341 9.43483L7.36676 10.1323L7.96009 10.5634H7.2267L7.00008 11.2609Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.013 10.0129L9.35952 9.67996L8.84092 10.1985L8.95568 9.47414L8.30225 9.14121L9.02658 9.02647L9.14132 8.30211L9.47425 8.9556L10.1986 8.84081L9.68002 9.35944L10.013 10.0129Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2611 7L10.5636 7.22665V7.96004L10.1325 7.36668L9.43506 7.59333L9.86613 7L9.43506 6.40667L10.1325 6.63332L10.5636 6.03996V6.77338L11.2611 7Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.013 3.98711L9.68004 4.64063L10.1986 5.1592L9.47423 5.04441L9.14132 5.6979L9.02658 4.97354L8.30225 4.85878L8.95568 4.52584L8.84092 3.80153L9.35955 4.32008L10.013 3.98711Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1320_8691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/Eur.2238237bd352b50c45de4f595278ded4.svg";
export { ForwardRef as ReactComponent };